import { render, staticRenderFns } from "./pageBottom.vue?vue&type=template&id=659431db&scoped=true&"
import script from "./pageBottom.vue?vue&type=script&lang=js&"
export * from "./pageBottom.vue?vue&type=script&lang=js&"
import style0 from "./pageBottom.vue?vue&type=style&index=0&id=659431db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659431db",
  null
  
)

export default component.exports